import { render, staticRenderFns } from "./CrawlOptions.vue?vue&type=template&id=5c596317&scoped=true&"
import script from "./CrawlOptions.vue?vue&type=script&lang=js&"
export * from "./CrawlOptions.vue?vue&type=script&lang=js&"
import style0 from "./CrawlOptions.vue?vue&type=style&index=0&id=5c596317&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c596317",
  null
  
)

export default component.exports